import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import NavBar from './components/NavBar';
import FilterBar from './components/FilterBar';
import theme from './theme';
import { useGlobalLoading } from './context/GlobalLoadingContext';
import { DataAndFilterContext } from './context/DataAndFilterContext';

import ConsideredSolutionsChartsOnly from './components/data_visualizations/ConsideredSolutionsChartsOnly';
import ReasonsNotChosenHeatmap from './components/data_visualizations/ReasonsNotChosenHeatmap';
import ConsideredSolutionsTable from './components/detail/tables/ConsideredSolutionsTable';

function ConsideredSolutionsPage() {
  const { loading } = useGlobalLoading();
  const { filteredData } = useContext(DataAndFilterContext);

  if (loading) return <Typography>Loading...</Typography>;

  return (
    <ThemeProvider theme={theme}>
      <NavBar />
      <Box sx={{ padding: 3 }}>
        <Typography variant="h4" gutterBottom>Buying Behaviors</Typography>
        <FilterBar />

        {/* 1) Pie + Line */}
        <Box my={4}>
          <ConsideredSolutionsChartsOnly />
        </Box>

        {/* 2) Heatmap */}
        <Box my={4}>
          <ReasonsNotChosenHeatmap filteredData={filteredData} />
        </Box>

        {/* 3) Table (uses the same filteredData) */}
        <Box my={4}>
          <ConsideredSolutionsTable customerStories={filteredData} />
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default ConsideredSolutionsPage;

